import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import { Subscription } from 'rxjs';
import {NzMessageService} from 'ng-zorro-antd/message';
import {TaskService} from '../../../services/task.service';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-table-pulse-abstract',
  templateUrl: './table-pulse-abstract.component.html',
  styleUrls: ['./table-pulse-abstract.component.css']
})
export class TablePulseAbstractComponent implements OnInit {
  dataSubscription: Subscription = null;
  boardData: any = {}; // 面板数据
  renderBoard: any;
  columnData: any;
  groupData: any;
  pulseData: any;
  currentUser: any; // 存放当前用户信息
  permissionDefinition: any;
  originalValue: string;
  filterData = {
    groups: [],
    selectedGroups: [],
    columns: []
  };
  isConfirmLoading = false; // 批量修改弹窗提交按钮状态
  buttonConfigStatus = true; // 按钮配置项显示状态
  buttonConfigTitle = null; // 按钮配置-标题
  buttonConfigDisabled = true; // 按钮配置-是否可用
  buttonConfigUrl = null; // 按钮配置-url
  buttonConfigEditStatus = false; // 按钮配置-是否编辑状态
  buttonConfigEditeData: any = {}; // 按钮配置-存放当前编辑项数据
  clickButtonLoading: boolean; // 按钮配置 - 按钮loading
  clickCurrentPulseValue = null; // 是否点击当前行
  @Input('boardData') set ChangeBoardData(data: any) {
    this.boardData = data;
  }
  @Input('renderBoard') set ChangeRenderBoard(data: any) {
    this.renderBoard = data;
  }
  @Input('column') set ChangeColumn(data: any) {
    this.columnData = data;
  }
  @Input('pulse') set ChangePulse(data: any) {
    this.pulseData = data;
  }
  @Input('group') set ChangeGroup(data: any) {
    this.groupData = data;
  }
  @Input('permissionDefinition') set ChangePermission(data: any) {
    this.permissionDefinition = data;
  }
  @Input('currentUser') set ChangeUser(data: any) {
    this.currentUser = data;
  }
  constructor(
    public message?: NzMessageService,
    public taskService?: TaskService,
    public datePipe?: DatePipe
  ) { }
  ngOnInit(): void {
  }
  // 修改行NAME
  modifyColumnName(pulseId, value, columnId) {
    if (value) {
      const param = {};
      param['name'] = value;
      if (this.originalValue !== value) {
        this.dataSubscription = this.taskService.doEditPulseName(pulseId, param).subscribe((res: any) => {
          this.originalValue = res.name;
          // this.updateFilterData(columnId);
        });
      }
    }
  }
  // 修改文本单元格编辑值
  modifyColumnText(pulse, column, value) {
    const param = {};
    param['pulseIds'] = [pulse.id];
    param['columnId'] = column.id;
    param['columnValue'] = value;
    if (!(value === null) && this.originalValue !== value) {
      this.dataSubscription = this.taskService.doEditPulse(this.groupData.boardId, param).subscribe((res: any) => {
        this.originalValue = value;
        // this.updateFilterData(column.id);
      });
    }
  }
  modifyColumnDateTime(pulseId, columnId, event) {
    const param = {};
    param['pulseIds'] = [pulseId];
    param['columnId'] = columnId;
    param['columnValue'] = event;
    this.dataSubscription = this.taskService.doEditPulse(this.groupData.boardId, param).subscribe((res: any) => {
      // this.updateFilterData(columnId);
    });
  }
  // 获取行日期组件编辑的值
  modifyColumnDate(pulseId, columnId, event) {
    const param = {};
    param['pulseIds'] = [pulseId];
    param['columnId'] = columnId;
    param['columnValue'] = {
      'date': event ? this.datePipe.transform(event, 'yyyy-MM-dd') : ''
    };
    this.dataSubscription = this.taskService.doEditPulse(this.groupData.boardId, param).subscribe((res: any) => {
      // this.updateFilterData(columnId);
    });
  }
  // 筛选
  updateFilterData(columnId) {
    let column: any = {};
    for (const item of this.boardData.boardData.columns) {
      if (item.id === columnId) {
        column = item;
        break;
      }
    }
    const columnValues = this.generateColumnValue(column);
    let filterColumn: any = {};
    for (const item of this.filterData.columns) {
      if (item.columnId === columnId) {
        filterColumn = item;
        break;
      }
    }
    if (filterColumn.columnValues) {
      filterColumn.columnValues.forEach(item => item.exist = false);
    }
    if (filterColumn.selectedValue) {
      filterColumn.selectedValue.forEach(item => item.exist = false);
    }
    if (column.type === 'link') {
      filterColumn.selectedValue = filterColumn.selectedValue.filter(item => {
        return columnValues.findIndex(value => value.value === item.value && value.title === item.title) > -1;
      });
      for (const item of columnValues) {
        item['exist'] = true;
        let flag = false;
        if (this.isExist(filterColumn.columnValues, item, 'value', 'title')) {
          flag = true;
          const index = filterColumn.columnValues.findIndex(value => value.value === item.value && value.title === item.title);
          filterColumn.columnValues[index] = item;
        }
        if (!flag) {
          if (this.isExist(filterColumn.selectedValue, item, 'value', 'title')) {
            const index = filterColumn.selectedValue.findIndex(value => value.value === item.value && value.title === item.title);
            filterColumn.selectedValue[index] = item;
          } else {
            filterColumn.columnValues.push(item);
          }
        }
      }
    } else {
      if (filterColumn.selectedValue) {
        filterColumn.selectedValue = filterColumn.selectedValue.filter(item => {
          return columnValues.findIndex(value => value.value === item.value) > -1;
        });
      }
      for (const item of columnValues) {
        item['exist'] = true;
        let flag = false;
        if (this.isExist(filterColumn.columnValues, item, 'value')) {
          flag = true;
          const index = filterColumn.columnValues.findIndex(value => value.value === item.value);
          filterColumn.columnValues[index] = item;
        }
        if (!flag) {
          if (this.isExist(filterColumn.selectedValue, item, 'value')) {
            const index = filterColumn.selectedValue.findIndex(value => value.value === item.value);
            filterColumn.selectedValue[index] = item;
          } else {
            filterColumn.columnValues.push(item);
          }
        }
      }
    }
    filterColumn.columnValues = filterColumn.columnValues.filter(item => item.exist);
    filterColumn.selectedValue = filterColumn.selectedValue.filter(item => item.exist);
  }
  generateColumnValue(column) {
    const columnValues = [];
    for (const pulse of this.boardData.boardData.pulses) {
      let o = {title: '', value: '', count: 1};
      const pulseValues = pulse.columnValues;
      switch (column.type) {
        case 'date-time':
        case 'date':
          const cellValue = pulseValues[column.id] && pulseValues[column.id]['date'] ? pulseValues[column.id]['date'] : '';
          o = {
            title: cellValue,
            value: cellValue,
            count: 1
          };
          if (!this.isExist(columnValues, o, 'value')) {
            columnValues.push(o);
          }
          break;
        case 'file':
          if (pulseValues[column.id] && pulseValues[column.id]['files'] && pulseValues[column.id]['files'].length > 0) {
            for (const file of pulseValues[column.id]['files']) {
              o = {title: file.name, value: file.name, count: 1};
              if (!this.isExist(columnValues, o, 'value')) {
                columnValues.push(o);
              }
            }
          } else {
            if (!this.isExist(columnValues, o, 'value')) {
              columnValues.push(o);
            }
          }
          break;
        case 'link':
          o = {
            title: pulseValues[column.id] ? pulseValues[column.id]['name'] : '',
            value: pulseValues[column.id] ? pulseValues[column.id]['url'] : '',
            count: 1
          };
          if (!this.isExist(columnValues, o, 'value', 'title')) {
            columnValues.push(o);
          }
          break;
        case 'name':
        case 'text':
          const textValue = pulseValues[column.id] || '';
          o = {title: textValue, value: textValue, count: 1};
          if (!this.isExist(columnValues, o, 'value')) {
            columnValues.push(o);
          }
          break;
        case 'multiple-person':
          if (pulseValues[column.id] && pulseValues[column.id]['personsAndTeams'] && pulseValues[column.id]['personsAndTeams'].length > 0) {
            for (const person of pulseValues[column.id]['personsAndTeams']) {
              o = {title: person.name, value: person.id, count: 1};
              if (!this.isExist(columnValues, o, 'value')) {
                columnValues.push(o);
              }
            }
          } else {
            if (!this.isExist(columnValues, o, 'value')) {
              columnValues.push(o);
            }
          }
          break;
        case 'status':
          let label = '';
          let color = '';
          if (pulseValues[column.id]) {
            const labels = column.labels;
            for (const l of labels) {
              if (l.index === pulseValues[column.id]['index']) {
                label = l.label;
                color = l.color;
                break;
              }
            }
          }
          o = {
            title: label,
            value: pulseValues[column.id] ? pulseValues[column.id]['index'] : '',
            count: 1
          };
          o['color'] = color;
          if (!this.isExist(columnValues, o, 'value')) {
            columnValues.push(o);
          }
          break;
        case 'dropdown':
          if (pulseValues[column.id] && pulseValues[column.id]['ids'] && pulseValues[column.id]['ids'].length > 0) {
            if (column.settings && column.settings.labels) {
              for (const id of pulseValues[column.id]['ids']) {
                for (const _label of column.settings.labels) {
                  if (id === _label.id) {
                    o = {title: _label.name, value: id, count: 1};
                    if (!this.isExist(columnValues, o, 'value')) {
                      columnValues.push(o);
                    }
                    break;
                  }
                }
              }
            }
          } else {
            if (!this.isExist(columnValues, o, 'value')) {
              columnValues.push(o);
            }
          }
          break;
        case 'select':
          if (pulseValues[column.id] && pulseValues[column.id]['option'] && column.config && column.config.option) {
            for (const option of column.config.option) {
              if (option.id === pulseValues[column.id]['option']) {
                o = {title: option.title, value: option.id, count: 1};
                if (!this.isExist(columnValues, o, 'value')) {
                  columnValues.push(o);
                }
                break;
              }
            }
          } else {
            if (!this.isExist(columnValues, o, 'value')) {
              columnValues.push(o);
            }
          }
          break;
        case 'check':
          if (pulseValues[column.id] === 'true') {
            o.title = '✔';
            o.value = 'true';
          }
          if (!this.isExist(columnValues, o, 'value')) {
            columnValues.push(o);
          }
          break;
      }
    }
    return columnValues;
  }
  isExist(arr: Array<any>, obj, attr, attr2?): boolean {
    if (arr) {
      for (const item of arr) {
        if (item[attr] === obj[attr]) {
          if (attr2) {
            if (item[attr2] === obj[attr2]) {
              item.count++;
              return true;
            }
          } else {
            item.count++;
            return true;
          }
        }
      }
      return false;
    }
  }
  // hasClass
  hasClass(elem, className) {
    const reg = new RegExp('(^|\\s+)' + className + '($|\\s+)');
    return reg.test(elem.className);
  }
  getTimeInterval(pulseId, columnId, event) {
    const param = {};
    param['pulseIds'] = [pulseId];
    param['columnId'] = columnId;
    if (event && event.length === 2) {
      const format = 'yyyy-MM-dd HH:mm';
      param['columnValue'] = {
        'date': [this.datePipe.transform(event[0], format), this.datePipe.transform(event[1], format)]
      };
    } else {
      param['columnValue'] = {
        'date': []
      };
    }
    this.dataSubscription = this.taskService.doEditPulse(this.groupData.boardId, param).subscribe((res: any) => {});
  }
  // 按钮组件-关联按钮点击事件
  buttonRelationClick(url, pulseId) {
    // todo 后台交互
    console.log(url + pulseId)
  }
  // 按钮组件-自定义按钮点击事件
  buttonCustomClick(column, pulse) {
    let url = '';
    column.config.original.forEach((item, index) => {
      if (item.id.toString() === pulse.columnValues[column.id].original.toString()) {
        url = item.url;
      }
    });
    const param = {
      'pulseId': pulse.id,
      'columnId': column.id
    };
    this.clickButtonLoading = true;
    this.dataSubscription = this.taskService.buttonClickEvent(url, param).subscribe((res: any) => {
      // this.nfUpdateTable.emit(true);
      this.clickButtonLoading = false;
    }, (err) => {
      this.clickButtonLoading = false;
    });
  }
  // 按钮组件-获取所有按钮已用ID
  getButtonUserIds(column) {
    let useIds = [];
    this.boardData.boardData.pulses.forEach((pulses, index) => {
      for (const item in pulses.columnValues) {
        if (pulses.columnValues.hasOwnProperty(item)) {
          if (pulses.columnValues[column.id].original) {
            useIds.push(pulses.columnValues[column.id].original);
          }
        }
      }
    });
    useIds = Array.from(new Set(useIds));
    return useIds;
  }
  // 按钮组件-按钮配置pop框
  openButtonConfig(pulseId, column) {
    this.clickCurrentPulseValue = pulseId;
    this.buttonConfigStatus = true;
    // 设置无法删除标识
    const userIds = this.getButtonUserIds(column);
    if (column.config.original && column.config.original.length > 0) {
      column.config.original.forEach((item, index) => {
        item.notRemove = false;
        for (let i = 0; i < userIds.length; i++) {
          if (item.id === userIds[i]) {
            item.notRemove = true;
          }
        }
      });
    }
  }
  // 按钮组件-删除
  removeButtonConfig(itemId, column) {
    column.config.original = column.config.original.filter(item => item.id !== itemId);
  }
  // 按钮组件-编辑
  editButtonConfig(item) {
    this.buttonConfigEditeData = item;
    this.buttonConfigStatus = !this.buttonConfigStatus;
    this.buttonConfigEditStatus = true;
    this.buttonConfigTitle = item.title;
    this.buttonConfigDisabled = item.usable;
    this.buttonConfigUrl = item.url;
  }
  // 按钮配置新增/编辑事件
  buttonConfigAdd() {
    this.buttonConfigTitle = null;
    this.buttonConfigDisabled = true;
    this.buttonConfigUrl = null;
    this.buttonConfigStatus = !this.buttonConfigStatus;
    this.buttonConfigEditStatus = false;
  }
  buttonConfigChange(event) {
    this.buttonConfigDisabled = event;
  }
  // 按钮配置提交
  buttonConfigSubmit(type, column) {
    if (!this.buttonConfigTitle) {
      this.message.create('error', '请输入按钮名称');
    } else {
      if (type === 'add') {
        const maxId = this.getMaxId(column.config.original) + 1;
        const addObj = {
          'id': maxId,
          'title': this.buttonConfigTitle,
          'type': 'primary',
          'usable': this.buttonConfigDisabled,
          'url': this.buttonConfigUrl
        };
        column.config.original = [
          ...column.config.original,
          addObj
        ];
      } else if (type === 'edit') {
        column.config.original.forEach((item, index) => {
          if (item.id === this.buttonConfigEditeData.id) {
            item.title = this.buttonConfigTitle;
            item.usable = this.buttonConfigDisabled;
            item.url = this.buttonConfigUrl;
          }
        });
      }
      const param = {
        'config': column.config
      };
      this.dataSubscription = this.taskService.doEditColumnHeader(this.groupData.boardId, column.id, param).subscribe((res: any) => {});
      this.buttonConfigStatus = !this.buttonConfigStatus;
    }
  }
  buttonSelectChange(event, pulseId, column) {
    const param = {};
    param['pulseIds'] = [pulseId];
    param['columnId'] = column.id;
    param['columnValue'] = {
      'original': event
    };
    this.dataSubscription = this.taskService.doEditPulse(this.groupData.boardId, param).subscribe((res: any) => {});
  }
  // 获取按钮ID
  getMaxId(data) {
    const ids = [];
    if (data && data.length > 0) {
      data.forEach((item, index) => {
        ids.push(item.id);
      });
      return ids.reduce((a, b) => {
        return b > a ? b : a;
      });
    } else {
      return 0;
    }
  }
}
